/* eslint-disable @typescript-eslint/no-explicit-any */

import { useState } from 'react'
import { cn } from '~/lib/utils'

const SocialButtons = ({ content, className }: any) => {
  const { buttons, eyebrow } = content
  const previewUrl =
    'https://preview-websitemodern-uni-hull.cloud.contensis.com'

  const path = content?.path || '/site-elements/icons/social/'
  const hoverPath = content?.hoverPath || '/site-elements/icons/'

  const [hoveredIdx, setHoveredIdx] = useState<number | null>(null)
  const [focusedIdx, setFocusedIdx] = useState<number | null>(null)

  return (
    <div className='sm:gap-xs flex flex-col gap-[2px]'>
      {eyebrow && <p className='tag'>{eyebrow}</p>}
      <div className='gap-2xs flex flex-wrap items-center'>
        {buttons &&
          buttons?.map((b: any, i: Index) => (
            <a
              key={i}
              href={b.link}
              aria-label={b.ariaLabel}
              className={cn(
                'unstyled-link p-2xs hover:bg-grey-l focus-visible:bg-grey-l rounded-full transition-colors',
                className
              )}
              target='_blank'
              rel='noreferrer'
              onMouseEnter={() => setHoveredIdx(i)}
              onMouseLeave={() => setHoveredIdx(null)}
              onFocus={() => setFocusedIdx(i)}
              onBlur={() => setFocusedIdx(null)}
            >
              <img
                className='sm:h-m sm:w-m h-s w-s'
                src={`${previewUrl}${hoveredIdx === i || focusedIdx === i ? hoverPath : path}${b.type}.svg`}
                alt={b.type}
              />
            </a>
          ))}
      </div>
    </div>
  )
}

export default SocialButtons
